
export interface AssignContact {
    id: number;
    first_name: string;
    last_name: string;
    profile_image: string;
    by: 'Employee' | 'Company' | 'Self Employee';
    role?: string;
}

export const mapAssignContact = (data:any): AssignContact => {
    if(!data){
        throw new Error('Invalied AssignContact type')
    }

    const AssignContact: AssignContact = {
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        profile_image: data.profile_image,
        by: data.by,
        role: data.role ?? '',
        
    }

    return AssignContact;

}

export const mapAssignContacts = (data: any[]): AssignContact[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid AssignContact data');
    }
  
    return data.map(mapAssignContact);
  };

export interface Tasks {
    task_id: number;
    project_reference: string;
    task_name: string;
    hours?: number;
    minute?: number;
    description?: string;
    deu_date: string;
    priority: 'High' | 'Medium' | 'Low';
    is_completed: number;
    assign: AssignContact[];
    assign_by?:AssignBy|null
}

export const mapTask = (data:any): Tasks => {
    if(!data){
        throw new Error('Invalied Task type')
    }
    
    const Task: Tasks = {
        task_id: data.task_id,
        project_reference: data.project_reference,
        task_name: data.task_name,
        hours: data.hours,
        minute: data.minute,
        description: data.description ?? '',
        deu_date: data.deu_date,
        priority: data.priority,
        is_completed: data.is_completed,
        assign: mapAssignContacts(data.assign),
        assign_by:(data.assign_by!=null)? mapAssignBy(data.assign_by):null,

    }

    return Task;

}

export const mapTasks = (data: any[]): Tasks[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid Task data');
    }
  
    return data.map(mapTask);
  };




  export interface AssignBy {
    first_name: string;
    last_name: string;
    profile_image: string;
}

export const mapAssignBy = (data:any): AssignBy => {
    if(!data){
        throw new Error('Invalied AssignContact type')
    }

    const AssignContact: AssignBy = {
        first_name: data.first_name,
        last_name: data.last_name,
        profile_image: data.profile_image,
    }

    return AssignContact;

}




export interface Assign {
    id: number;
    by: 'Employee' | 'Company' | 'Self Employee';
}

export interface CreateTaskArray {
    created_token: string;
    task_name: string;
    description?: string;
    deu_date: string;
    hours?: number|0;
    minute?: number|0;
    priority?: string;
    assign: AssignContact[] ;
}

export interface Projects {
    project_id: number;
    job_number: number;
    project_type: 'CP' | 'DP';
    address: string;
}